
(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.Widget = this.HyperMD.Widget || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resetWidgetCreators = exports.getWidgetCreator = exports.registerWidgetCreator = void 0;
    var widgetMap = {};
    /**
     *
     * @param name Name of the widget
     * @param creator Creator function
     */
    function registerWidgetCreator(name, creator, forceOverride) {
        if (forceOverride === void 0) { forceOverride = false; }
        if (name in widgetMap && !forceOverride) {
            throw new Error("Widget with name " + name + " is already registered");
        }
        widgetMap[name] = creator;
    }
    exports.registerWidgetCreator = registerWidgetCreator;
    /**
     *
     * @param name Name of the widget
     */
    function getWidgetCreator(name) {
        return widgetMap[name];
    }
    exports.getWidgetCreator = getWidgetCreator;
    function resetWidgetCreators() {
        widgetMap = {};
    }
    exports.resetWidgetCreators = resetWidgetCreators;
});
